import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PluginObject } from 'vue/types/umd';

import * as lantern from '@lantern/lantern-sdk';
import { InternalAxiosRequestConfig } from 'axios';

export interface SDKOptions {
    host: string;
    tokenRefreshFn?: () => Promise<{ accessToken: string; permissionToken: string }>;
    waitForRefresh?: (config: InternalAxiosRequestConfig) => Promise<InternalAxiosRequestConfig>;
}

interface SDKConstructorOptions {
    host: string;
    tokenRefreshFn?: () => Promise<{ accessToken: string; permissionToken: string }>;
    waitForRefresh?: (config: InternalAxiosRequestConfig) => Promise<InternalAxiosRequestConfig>;
}

@Component
export class SDK extends Vue {
    private static _instance: lantern.SDK;
    private static options: SDKConstructorOptions;

    public static get instance() {
        return SDK._instance;
    }

    public static LanternSDKPlugin: PluginObject<SDKOptions> = {
        install(vue: Vue.VueConstructor<Vue>, options: SDKOptions = { host: '' }) {
            SDK.options = {
                ...options
            };
            const { host, tokenRefreshFn, waitForRefresh } = options;
            SDK._instance = lantern.SDK.instance;
            if (tokenRefreshFn && waitForRefresh)
                SDK._instance.setTokenRefreshFn(tokenRefreshFn, waitForRefresh);
            SDK._instance.host = host;
            (<any>vue).prototype.$lantern = SDK._instance;
        }
    };
}
